import "./Main.css"
import Test from "../Test/Test"
import { useState } from "react";
import Modal from "../Modal/Modal"

function Main(){
  
    // when Modal is set to true it will be displayed
     const [isModalOpen, setModalOpen] = useState(false);

    // returns the whole main: info text, the test and information about the company with link. 
    return(<>
    <div className="mainbody">
        
        <div className="">
            <h2>Amblyopi</h2>
            <p className="text">
            Nedan kan du testa dig genom att separera höger och vänster sida med en bok eller liknande. Kom så nära avdelningen som möjligt med ett öga på vardera sida. Kan du samtidigt se båda bokstäverna A och B så har du inte 
            <button className="popup" onClick={() => setModalOpen(true)}> Amblyopi</button>
            </p>           
            
            <Modal
            isOpen={isModalOpen}
            onClose={() => setModalOpen(false)}
            />
        </div>

        <Test/>

        <div className="text">
            <p>Imvilabs är ett innovativt företag som erbjuder en specialiserad träningsmetod för att förbättra ögonkoordination och läsförmåga. Genom en kombination av VR-teknik och streamat innehåll hjälper de personer med olika typer av synrelaterade utmaningar som dyslexi, ADHD, konvergensinsuffiens och läs- och skrivsvårigheter. Träningen, som rekommenderas utföras 15 minuter 4 gånger i veckan under 12 veckor, har visat en genomsnittlig ökning av läshastigheten med 60% och har framgångsrikt hjälpt personer i åldrarna 7-81 år.</p>
            <a className="acontact" href="https://imvilabs.com/om-oss/#contact">Kontakta oss</a>
        </div>
    </div>
    </>)
}

export default Main